import React from "react";

const Resume = ({ data }) => {
  if (!data) {
    return <section id="resume" />;
  }

  if (data) {
    var skillmessage = data.skillmessage;
    var education = data.education.map(function (education) {
      return (
        <div key={education.school}>
          <h3>{education.school}</h3>
          <p className="info">
            {education.degree} <span>&bull;</span>{" "}
            <em className="date">{education.graduated}</em>
            {education.location ? (
              <>
                {" "}
                <span>&bull;</span>{" "}
                <em className="date">{education.location}</em>
              </>
            ) : null}
          </p>
          <p>{education.description}</p>
        </div>
      );
    });
    var work = data.work.map(function (work) {
      return (
        <div key={work.company}>
          <h3>{work.company}</h3>
          <p className="info">
            {work.title}
            <span>&bull;</span> <em className="date">{work.years}</em>
            {work.location ? (
              <>
                {" "}
                <span>&bull;</span>{" "}
                <em className="date">{work.location}</em>
              </>
            ) : null}
          </p>

          {Array.isArray(work.highlights) && work.highlights.length > 0 ? (
            <ul className="work-highlights">
              {work.highlights.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          ) : work.description ? (
            <p>{work.description}</p>
          ) : null}

          {Array.isArray(work.links) && work.links.length > 0 ? (
            <p className="work-links">
              {work.links.map((l) => (
                <a
                  key={l.url}
                  className="work-link"
                  href={l.url}
                  target="_blank"
                  rel="noreferrer"
                >
                  {l.label}
                </a>
              ))}
            </p>
          ) : work.website ? (
            <p className="work-links">
              <a
                className="work-link"
                href={work.website}
                target="_blank"
                rel="noreferrer"
              >
                {work.website}
              </a>
            </p>
          ) : null}
        </div>
      );
    });
    var skills = (Array.isArray(data.skills) ? data.skills : []).map(function (skills) {
      var className = "bar-expand " + skills.name.toLowerCase();
      return (
        <li key={skills.name}>
          <span style={{ width: skills.level }} className={className}></span>
          <em>{skills.name}</em>
        </li>
      );
    });

    var skillCategories = Array.isArray(data.skillCategories)
      ? data.skillCategories
      : [];
    var languages = Array.isArray(data.languages) ? data.languages : [];
  }

  return (
    <section id="resume">
      <div className="row work">
        <div className="three columns header-col">
          <h1>
            <span>Experience</span>
          </h1>
        </div>

        <div className="nine columns main-col">{work}</div>
      </div>

      <div className="row education">
        <div className="three columns header-col">
          <h1>
            <span>Education</span>
          </h1>
        </div>

        <div className="nine columns main-col">
          <div className="row item">
            <div className="twelve columns">{education}</div>
          </div>
        </div>
      </div>

      <div className="row skill">
        <div className="three columns header-col">
          <h1>
            <span>Skills</span>
          </h1>
        </div>

        <div className="nine columns main-col">
          <p>{skillmessage}</p>

          {skillCategories.length > 0 && (
            <div className="skill-categories">
              {skillCategories.map((cat) => (
                <div className="skill-category" key={cat.title}>
                  <h4 className="skill-category-title">{cat.title}</h4>
                  <div className="skill-pills">
                    {(cat.items || []).map((item) => (
                      <span className="skill-pill" key={item}>
                        {item}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}

          {skills.length > 0 && (
            <div className="bars">
              <ul className="skills">{skills}</ul>
            </div>
          )}
        </div>
      </div>

      {languages.length > 0 && (
        <div className="row languages">
          <div className="three columns header-col">
            <h1>
              <span>Languages</span>
            </h1>
          </div>
          <div className="nine columns main-col">
            <ul className="language-list">
              {languages.map((l) => (
                <li key={l.name}>
                  <strong>{l.name}</strong>
                  {l.level ? ` (${l.level})` : null}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </section>
  );
};

export default Resume;
